require("@coreui/coreui");
require("lightbox2/dist/js/lightbox");

import "../src/css/coreui.scss"
